import React from 'react';
import { SparklesIcon, CheckCircleIcon, HeartIcon } from 'lucide-react';
export function FuturePacing() {
  const outcomes = ['Dominas los fundamentos del High Ticket Closing con confianza', 'Realizas tus primeras conversaciones de valor con seguridad', 'Tu familia nota el cambio en tu energía y propósito', 'Tu tiempo finalmente te pertenece', 'Formas parte de una comunidad de closers en crecimiento'];
  return <section className="w-full px-4 py-16 md:py-24 bg-lightBg" data-id="element-65">
      <div className="max-w-5xl mx-auto" data-id="element-66">
        <div className="flex items-center justify-center gap-3 mb-8" data-id="element-67">
          <SparklesIcon className="w-8 h-8 md:w-10 md:h-10 text-primary" data-id="element-68" />
          <h2 className="text-[28px] md:text-[40px] lg:text-[56px] font-bold font-poppins text-textDark text-center tracking-tight uppercase" data-id="element-69">
            Proyéctate Al Futuro
          </h2>
        </div>
        <p className="text-[24px] md:text-[32px] lg:text-[42px] font-bold font-poppins text-center text-primary mb-10 tracking-tight uppercase" data-id="element-70">
          Imagínate dentro de 6 meses...
        </p>
        <div className="bg-dark p-8 md:p-16 rounded-3xl border-4 border-primary mb-10 shadow-2xl" data-id="element-71">
          <div className="space-y-5" data-id="element-72">
            {outcomes.map((outcome, index) => <div key={index} className="flex items-start gap-3 bg-lightBg p-6 rounded-2xl transform hover:scale-105 transition-all duration-300" data-id="element-73">
                <CheckCircleIcon className="w-7 h-7 text-primary flex-shrink-0" data-id="element-74" />
                <p className="text-[16px] md:text-[18px] font-bold font-inter text-textDark leading-relaxed" data-id="element-75">
                  {outcome}
                </p>
              </div>)}
          </div>
        </div>
        <div className="text-center space-y-8" data-id="element-76">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-77">
            <HeartIcon className="w-8 h-8 text-primary fill-primary" data-id="element-78" />
            <HeartIcon className="w-8 h-8 text-primary fill-primary" data-id="element-79" />
            <HeartIcon className="w-8 h-8 text-primary fill-primary" data-id="element-80" />
          </div>
          <p className="text-[18px] md:text-[22px] font-inter text-textDark leading-relaxed max-w-[30ch] mx-auto" data-id="element-81">
            Siente esa satisfacción profunda...{' '}
            <span className="text-primary font-bold" data-id="element-82">
              Esa paz de saber que tomaste la decisión correcta.
            </span>
          </p>
          <div className="bg-dark p-8 md:p-12 rounded-3xl border-4 border-primary shadow-2xl" data-id="element-83">
            <p className="text-[24px] md:text-[32px] lg:text-[42px] font-bold font-poppins text-white mb-5 tracking-tight uppercase" data-id="element-84">
              Todo comienza con una decisión:
            </p>
            <p className="text-[22px] md:text-[28px] font-bold font-inter text-primary uppercase tracking-wide" data-id="element-85">
              Dar el primer paso hoy.
            </p>
          </div>
          <p className="text-[16px] md:text-[18px] font-inter text-textDark italic leading-relaxed" data-id="element-86">
            El futuro que visualizas está esperándote...
          </p>
        </div>
      </div>
    </section>;
}